/* Zillabeau wishlist — no app. localStorage for everyone; synced to the Zillabeau worker for signed-in customers.
   Config: <script type="application/json" id="zbm-config">{"worker":"https://…","customerId":"123","sig":"hmac"}</script> (theme.liquid)
   Markup: <button data-zbm-wl data-handle="product-handle" aria-pressed="false">…</button>  (snippets/zbm-wishlist-btn.liquid)
           <span data-zbm-wl-count>0</span>  (header)
   Events: document 'zbm:wishlist' {detail:{handles:[…]}} after every change. */
(function () {
  if (window.ZBMWishlist) return;
  var KEY = 'zbm_wishlist_v1';
  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('zbm-config') || {}).textContent || '{}') || {}; } catch (e) {}
  var worker = String(cfg.worker || '').replace(/\/+$/, '');
  var cid = cfg.customerId ? String(cfg.customerId) : '';
  var sig = cfg.sig ? String(cfg.sig) : '';
  var state = { handles: [], updated: 0 };
  var saveTimer = null;

  function load() { try { var j = JSON.parse(localStorage.getItem(KEY) || 'null'); if (j && Array.isArray(j.handles)) state = { handles: j.handles.slice(0, 500), updated: +j.updated || 0 }; } catch (e) {} }
  function persist() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  function emit() {
    document.querySelectorAll('[data-zbm-wl]').forEach(function (b) { b.setAttribute('aria-pressed', state.handles.indexOf(b.getAttribute('data-handle')) !== -1 ? 'true' : 'false'); });
    document.querySelectorAll('[data-zbm-wl-count]').forEach(function (c) { c.textContent = state.handles.length; c.hidden = state.handles.length === 0; });
    try { document.dispatchEvent(new CustomEvent('zbm:wishlist', { detail: { handles: state.handles.slice() } })); } catch (e) {}
  }
  function canSync() { return !!(worker && cid && sig); }
  function syncUp() {
    if (!canSync()) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      fetch(worker + '/wishlist/' + cid + '?sig=' + encodeURIComponent(sig), { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ handles: state.handles }) }).catch(function () {});
    }, 600);
  }
  function syncDown() {
    if (!canSync()) return Promise.resolve();
    return fetch(worker + '/wishlist/' + cid + '?sig=' + encodeURIComponent(sig), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !Array.isArray(j.handles)) return;
        // union: anything saved on another device joins this one; local additions are pushed back
        var merged = j.handles.slice();
        state.handles.forEach(function (h) { if (merged.indexOf(h) === -1) merged.push(h); });
        var changed = merged.length !== j.handles.length;
        state.handles = merged.slice(0, 500); persist(); emit();
        if (changed) syncUp();
      }).catch(function () {});
  }

  var api = {
    get: function () { return state.handles.slice(); },
    has: function (h) { return state.handles.indexOf(h) !== -1; },
    add: function (h) { if (!h || api.has(h)) return; state.handles.unshift(h); state.updated = Date.now(); persist(); emit(); syncUp(); },
    remove: function (h) { var i = state.handles.indexOf(h); if (i === -1) return; state.handles.splice(i, 1); state.updated = Date.now(); persist(); emit(); syncUp(); },
    toggle: function (h) { api.has(h) ? api.remove(h) : api.add(h); return api.has(h); },
    clear: function () { state.handles = []; state.updated = Date.now(); persist(); emit(); syncUp(); },
    refresh: emit
  };
  window.ZBMWishlist = api;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-zbm-wl]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-handle');
    var on = api.toggle(h);
    b.classList.add('is-bump'); setTimeout(function () { b.classList.remove('is-bump'); }, 180);
    var live = b.querySelector('[data-zbm-wl-live]');
    if (live) live.textContent = on ? 'Saved to wishlist' : 'Removed from wishlist';
  });

  /* One-time move from the old iWish (Wishlist Prime) app (Sean 2026-10-02, "B" plan — the vendor never sent an export).
     For a signed-in customer the iWish app itself pulls their saved list and stores it in localStorage.iwish_list
     ([[variantId, qty], …]) with iwish_sync="true". We read that once, turn variant ids into product handles via the
     storefront /variants/<id> redirect, merge them into our list (no duplicates) and mark the customer as done.
     Nothing is removed from iWish. Remove this block after the iWish app is uninstalled. */
  var MIG = 'zbm_iwish_migrated_' + cid;
  function migrateIwish(tries) {
    if (!cid) return;
    try { if (localStorage.getItem(MIG)) return; } catch (e) { return; }
    var synced = false, list = [];
    try { synced = localStorage.getItem('iwish_sync') === 'true'; list = JSON.parse(localStorage.getItem('iwish_list') || '[]'); } catch (e) {}
    if (!synced) { if (tries < 8) setTimeout(function () { migrateIwish(tries + 1); }, 1500); return; } // iWish syncs right after login
    var ids = (Array.isArray(list) ? list : []).map(function (p) { return String(Array.isArray(p) ? p[0] : p); }).filter(function (v) { return /^\d+$/.test(v); }).slice(0, 300);
    var done = function (n) { try { localStorage.setItem(MIG, JSON.stringify({ at: Date.now(), found: ids.length, added: n })); } catch (e) {} };
    if (!ids.length) { done(0); return; }
    var handles = [], i = 0;
    function next() {
      if (i >= ids.length) {
        var added = 0;
        handles.forEach(function (h) { if (state.handles.indexOf(h) === -1) { state.handles.push(h); added++; } });
        if (added) { state.handles = state.handles.slice(0, 500); state.updated = Date.now(); persist(); emit(); syncUp(); }
        done(added); return;
      }
      var batch = ids.slice(i, i + 5); i += 5;
      Promise.all(batch.map(function (id) {
        return fetch('/variants/' + id, { method: 'HEAD', redirect: 'follow', credentials: 'same-origin' })
          .then(function (r) { var m = (r.url || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; })
          .catch(function () { return null; });
      })).then(function (hs) { hs.forEach(function (h) { if (h && handles.indexOf(h) === -1) handles.push(h); }); next(); });
    }
    next();
  }

  load(); emit(); syncDown().then(function () { setTimeout(function () { migrateIwish(0); }, 800); });
  document.addEventListener('shopify:section:load', emit);
})();
